<div class="page">
  <app-section-toolbar
    [sectionTitle]="'MISSION.INFORMATION' | translate"
    [hasStatus]="false"
    (back)="backToMissionConfig()">
  </app-section-toolbar>

  @if (mission) {
    <div class="columns">
      <section class="card">
        <div class="card__header">
          <div class="card__title">{{ 'MISSION.INFO.UNIT_CATALYST_CHARACTERISTICS' | translate }}</div>
        </div>
        <dl class="card__body kv-list">
          <dt>{{ 'MISSION.INFO.UNIT' | translate }}</dt><dd>{{ mission.unitName }}</dd>
          <dt>{{ 'MISSION.INFO.UNIT_TYPE' | translate }}</dt><dd>{{ mission.unitypeName }}</dd>
          <dt>{{ 'MISSION.INFO.CATALYST_WEIGHT' | translate }}</dt><dd>{{ mission.catalystWeight | number : '1.0-0' }} {{ mission.tonUom }}</dd>
          <dt>{{ 'MISSION.INFO.CATALYST_MANUFACTURER' | translate }}</dt><dd>{{ mission.catalystProvider }}</dd>
          <dt>{{ 'MISSION.INFO.CATALYST_NAME' | translate }}</dt><dd>{{ mission.catalystName }}</dd>
          <dt>{{ 'MISSION.INFO.SULFIDING_RESPONSIBLE' | translate }}</dt><dd>{{ mission.catalystproviderName }}</dd>
          @for (reactor of reactors; track reactor; let i = $index) {
            <dt>{{ i === 0 ? ('MISSION.INFO.REACTOR_BEDS' | translate) : '' }}</dt><dd>{{ reactor.reactorName }} / {{ reactor.bedNumber == null ? '?' : reactor.bedNumber }}</dd>
          }
          <dt>{{ 'MISSION.INFO.CATALYST_FIXABLE_SULFUR' | translate }}</dt><dd>{{ mission.catalystStoechioSulfur }} %</dd>
        </dl>
      </section>
      <section class="card">
        <div class="card__header">
          <div class="card__title">{{ 'MISSION.INFO.UNIT_WORKING_CONDITIONS' | translate }}</div>
        </div>
        <dl class="card__body kv-list">
          <dt>{{ 'MISSION.INFO.FEEDSTOCK_FLOWRATE' | translate }}</dt><dd>{{ mission.feedstockFlowrate | number : '1.0-2' }} {{ mission.cubicFlowrateUom }}</dd>
          <dt>{{ 'MISSION.INFO.FEEDSTOCK_TYPE' | translate }}</dt><dd>{{ mission.feedstocknatureName }}</dd>
          <dt>{{ 'MISSION.INFO.FEEDSTOCK_SULFUR' | translate }}</dt><dd>{{ mission.feedstockSulfurcontent }} %</dd>
          <dt>{{ 'MISSION.INFO.FEEDSTOCK_RECYCLING' | translate }}</dt><dd>{{ (mission.feedstockRecycling ? 'YES' : 'NO') | translate }}</dd>
          <dt>{{ 'MISSION.INFO.GAS_RECYCLING' | translate }}</dt><dd>{{ (mission.H2Recycling ? 'YES' : 'NO') | translate }}</dd>
          <dt>{{ 'MISSION.INFO.UNIT_PRESSURE' | translate }}</dt><dd>{{ mission.unitWorkingPressure | number : '1.0-2' }} {{ mission.pressureUom }}</dd>
          <dt>{{ 'MISSION.INFO.H2_FLOWRATE' | translate }}</dt><dd>{{ mission.H2Flowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</dd>
        </dl>
      </section>
      <section class="card">
        <div class="card__header">
          <div class="card__title">{{ 'MISSION.INFO.DMDS_INJECTION' | translate }}</div>
        </div>
        <dl class="card__body kv-list">
          <dt>{{ 'MISSION.INFO.CATALYST_STOECHIO' | translate }}</dt><dd>{{ mission.catalystStoechioDMDS }} %</dd>
          <dt>{{ 'MISSION.INFO.MIN_FLOWRATE' | translate }}</dt><dd>{{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</dd>
          <dt>{{ 'MISSION.INFO.MAX_FLOWRATE' | translate }}</dt><dd>{{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</dd>
          <dt>{{ 'MISSION.INFO.INJECTION_PRESSURE' | translate }}</dt><dd>{{ mission.unitDMDSInjectionPointPressure | number : '1.0-2' }} {{ mission.pressureUom }}</dd>
          <dt class="kv-heading">{{ 'PRODUCT.LABEL' | translate }}</dt><dd class="kv-heading">{{ 'MISSIONS.ORDERED_QUANTITY' | translate }}</dd>
          @for (product of mission.products; track product) {
            <dt>{{ product.productName }}</dt><dd>{{ product.productmissionLoadedExpectedMassTotal }} {{ mission.weightUom }}</dd>
          }
        </dl>
      </section>
    </div>
  }
</div>
